(function (global) {
  'use strict';

  function cartItems(config, warrantySelected) {
    if (config.comingSoon) throw new Error('Coming soon. Please use Notify Me for launch updates.');
    if (!config.published) throw new Error('This product is in private preview and is not available to purchase yet.');
    if (!config.available) throw new Error('This product is currently unavailable.');
    if (!/^\d+$/.test(String(config.variantId))) throw new Error('Please refresh the page before adding this product.');
    const items = [{ id: String(config.variantId), quantity: 1 }];
    if (warrantySelected) {
      if (!/^\d+$/.test(String(config.warrantyVariant || ''))) throw new Error('The extended warranty is not available to add yet. Please contact our team.');
      items.push({ id: String(config.warrantyVariant), quantity: 1 });
    }
    return items;
  }

  function notifyArguments(product, variantId, productId) {
    if (!product || String(product.id) !== String(productId) || !Array.isArray(product.variants)) return null;
    const variant = product.variants.find(item => String(item.id) === String(variantId));
    if (!variant) return null;
    // AU is intentionally coming soon even though other markets have stock.
    // Supply that market availability to the modal without altering inventory
    // or Stoq's shared product configuration.
    const upcomingProduct = { ...product, available: false, variants: [{ ...variant, available: false }] };
    return [upcomingProduct, String(variant.id)];
  }

  function dateLabels(now, processing, minDelivery, maxDelivery) {
    const add = (days) => { const d = new Date(now); d.setDate(d.getDate() + days); return d; };
    const fmt = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }).toUpperCase();
    const range = (a, b) => fmt(a) === fmt(b) ? fmt(a) : a.getMonth() === b.getMonth() && a.getFullYear() === b.getFullYear() ? fmt(a) + ' - ' + b.getDate() : fmt(a) + ' - ' + fmt(b);
    return { purchased: fmt(now), processing: range(now, add(processing)), delivered: range(add(processing + minDelivery), add(processing + maxDelivery)) };
  }

  function init(root) {
    if (!root || root.dataset.irHatReady === 'true') return;
    root.dataset.irHatReady = 'true';
    const config = { comingSoon: root.dataset.comingSoon === 'true', variantId: root.dataset.variantId, warrantyVariant: root.dataset.warrantyVariant, published: root.dataset.productPublished === 'true', available: root.dataset.available === 'true' };
    const basePrice = Number(root.dataset.price) || 0;
    const warrantyPrice = Number(root.dataset.warrantyPrice) || 0;
    const currency = root.dataset.currency || 'AUD';
    const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency, currencyDisplay: 'narrowSymbol', minimumFractionDigits: 2 }).format(cents / 100);
    let noticeTimeout;
    const notice = (message) => {
      let box = root.querySelector('[data-ir-hat-notice]');
      if (!box) { box = document.createElement('div'); box.dataset.irHatNotice = ''; box.setAttribute('role', 'status'); root.appendChild(box); }
      box.textContent = message; box.hidden = false;
      clearTimeout(noticeTimeout); noticeTimeout = setTimeout(() => { box.hidden = true; }, 7000);
    };

    const thumbs = [...root.querySelectorAll('[data-ir-gallery-pick]')];
    const main = root.querySelector('[data-ir-gallery-main]');
    const sources = thumbs.map(b => b.querySelector('img'));
    const counter = root.querySelector('[data-ir-gallery-counter]');
    let current = 0;
    function setGallery(index) {
      if (!main || !sources.length) return;
      current = (index + sources.length) % sources.length;
      main.src = sources[current].src;
      if (sources[current].srcset) main.srcset = sources[current].srcset;
      else main.removeAttribute('srcset');
      main.alt = sources[current].alt || 'Infraredi Hair Growth Hat — image ' + (current + 1);
      thumbs.forEach((b, i) => { b.style.outline = i === current ? '2px solid #141414' : 'none'; b.style.opacity = i === current ? '1' : '.7'; b.setAttribute('aria-current', String(i === current)); });
      root.querySelectorAll('[data-ir-gallery-hotspots]').forEach(e => { e.hidden = current !== 0; });
      if (counter) counter.textContent = (current + 1) + ' / ' + sources.length;
    }
    thumbs.forEach((b, i) => b.addEventListener('click', () => setGallery(i)));
    root.querySelectorAll('[data-ir-gallery-direction]').forEach(b => b.addEventListener('click', () => setGallery(current + Number(b.dataset.irGalleryDirection))));
    const touchArea = root.querySelector('[data-ir-gallery-touch]');
    if (touchArea) {
      let start;
      touchArea.addEventListener('touchstart', e => { start = e.touches[0] && [e.touches[0].clientX, e.touches[0].clientY]; }, { passive: true });
      touchArea.addEventListener('touchend', e => {
        const t = e.changedTouches[0]; if (!start || !t) return;
        const dx = t.clientX - start[0], dy = t.clientY - start[1]; start = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) setGallery(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
      touchArea.addEventListener('touchcancel', () => { start = null; }, { passive: true });
    }

    const scrollTo = (selector) => {
      const target = root.querySelector(selector); if (!target) return;
      const header = document.querySelector('hdt-sticky-header');
      const offset = (header ? header.getBoundingClientRect().height : 0) + 24;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    root.querySelectorAll('[data-ir-hat-scroll]').forEach(el => el.addEventListener('click', e => { e.preventDefault(); scrollTo(el.dataset.irHatScroll); }));

    root.querySelectorAll('[data-ir-hat-intercom]').forEach(button => button.addEventListener('click', () => {
      const open = () => {
        if (typeof window.Intercom !== 'function') return false;
        window.Intercom('show');
        return true;
      };
      if (open() || root._irHatChatTimer) return;
      button.setAttribute('aria-busy', 'true');
      const started = Date.now();
      root._irHatChatTimer = setInterval(() => {
        const opened = open();
        if (!opened && Date.now() - started < 30000) return;
        clearInterval(root._irHatChatTimer); root._irHatChatTimer = null;
        button.removeAttribute('aria-busy');
        if (!opened) notice('Chat could not load. Please refresh and try again, or email support@infraredi.com.');
      }, 200);
    }));

    const disclosures = [...root.querySelectorAll('[data-ir-collapsible]')];
    disclosures.forEach((item, i) => {
      const trigger = item.children[0], panel = item.children[1]; if (!trigger || !panel) return;
      panel.id = 'ir-hat-panel-' + root.dataset.sectionId + '-' + i;
      trigger.setAttribute('aria-controls', panel.id);
      const toggle = () => {
        const open = item.dataset.state !== 'open'; item.dataset.state = open ? 'open' : 'closed'; panel.dataset.state = item.dataset.state;
        panel.hidden = !open; trigger.setAttribute('aria-expanded', String(open));
        if (open) { panel.style.height = 'auto'; panel.style.setProperty('--radix-collapsible-content-height', 'auto'); }
      };
      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
    root.querySelectorAll('[data-ir-hat-terms]').forEach(el => el.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      const target = root.querySelector('#ir-hat-shipping-returns');
      if (target && target.dataset.state !== 'open') target.children[0].click();
      scrollTo('#ir-hat-shipping-returns');
    }));

    const warranty = root.querySelector('[data-ir-ew-checkbox]');
    if (warranty) warranty.addEventListener('change', () => {
      const row = warranty.closest('label'), tick = row.querySelector('[data-ir-ew-tick]'), box = tick?.parentElement;
      row.style.borderColor = warranty.checked ? '#FF4C58' : '#E3E3E8'; row.style.background = warranty.checked ? '#FFF7F7' : '#fff';
      if (box) { box.style.background = warranty.checked ? '#FF4C58' : '#fff'; box.style.borderColor = warranty.checked ? '#FF4C58' : '#C9C9D1'; }
      if (tick) tick.hidden = !warranty.checked;
      root.querySelectorAll('[data-ir-hat-add] [data-ir-hat-price]').forEach(el => { el.textContent = money(basePrice + (warranty.checked ? warrantyPrice : 0)); });
    });
    root.querySelectorAll('[data-ir-hat-sale-only]').forEach(el => { el.hidden = !(Number(root.dataset.comparePrice) > basePrice); });

    const buttons = [...root.querySelectorAll('[data-ir-hat-add]')];
    if (!config.available) {
      buttons.forEach(button => {
        button.textContent = 'Out Of Stock - Notify Me';
        button.setAttribute('data-ir-dynamic-sold-out-control', '');
        button.removeAttribute('disabled');
        button.setAttribute('aria-disabled', 'false');
      });
    }
    // Use the same Stoq modal integration as the US Pro Series pages.
    const openNotify = () => {
      const attempt = () => {
        const stoq = window._RestockRocket || window._Stoq;
        const settings = window._RestockRocketConfig || window._StoqConfig;
        const args = notifyArguments(settings?.product, config.variantId, root.dataset.productId);
        if (!stoq || typeof stoq.openModal !== 'function' || !args) return false;
        try { stoq.openModal(...args); return true; } catch (_) { return false; }
      };
      if (attempt()) return;
      if (root._irHatNotifyTimer) return;
      const started = Date.now();
      buttons.forEach(button => button.setAttribute('aria-busy', 'true'));
      root._irHatNotifyTimer = setInterval(() => {
        const opened = attempt();
        if (!opened && Date.now() - started < 60000) return;
        clearInterval(root._irHatNotifyTimer); root._irHatNotifyTimer = null;
        buttons.forEach(button => button.removeAttribute('aria-busy'));
        if (!opened) notice('The notification form could not load. Please refresh and try again.');
      }, 100);
    };
    let adding = false;
    async function addToCart() {
      if (!config.available || config.comingSoon) { openNotify(); return; }
      if (adding) return;
      try {
        const items = cartItems(config, !!warranty?.checked);
        adding = true; buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        const formData = new FormData();
        if (items.length > 1) items.forEach((item, i) => { formData.set('items[' + i + '][id]', item.id); formData.set('items[' + i + '][quantity]', '1'); });
        else { formData.set('id', items[0].id); formData.set('quantity', '1'); }
        if (!window.InfrarediKallesCart) throw new Error('The cart is still loading. Please try again.');
        await window.InfrarediKallesCart.add({ root, item: items[0], formData, productId: root.dataset.productId, actionAfterATC: 'open_cart_drawer' });
      } catch (err) { notice(err.message || 'Unable to add this item. Please try again.'); }
      finally { adding = false; buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); }); }
    }
    buttons.forEach(b => b.addEventListener('click', addToCart));
    root.querySelector('form')?.addEventListener('submit', e => { e.preventDefault(); addToCart(); });

    const sticky = root.querySelector('[data-ir-sticky]');
    if (sticky && buttons[0] && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([e]) => {
        const show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)'; sticky.setAttribute('aria-hidden', String(!show)); sticky.inert = !show;
      });
      observer.observe(buttons[0]);
      root._irHatObserver = observer;
    }
    function updateDates() {
      const labels = dateLabels(new Date(), Number(root.dataset.processingDays) || 0, Number(root.dataset.deliveryMin) || 0, Number(root.dataset.deliveryMax) || 0);
      root.querySelectorAll('[data-ir-date]').forEach(el => { el.textContent = labels[el.dataset.irDate]; });
    }
    updateDates();
    root._irHatTimer = setInterval(updateDates, 60000);
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { cartItems, dateLabels, notifyArguments };
  if (typeof document !== 'undefined') {
    const ready = () => document.querySelectorAll('[data-ir-hair-growth]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
    document.addEventListener('shopify:section:load', ready);
    document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-ir-hair-growth]').forEach(root => { clearInterval(root._irHatTimer); clearInterval(root._irHatNotifyTimer); clearInterval(root._irHatChatTimer); root._irHatObserver?.disconnect(); }));
  }
})(typeof window !== 'undefined' ? window : globalThis);
